// import { io } from 'socket.io-client';

// class SocketioService {
//   socket;
//   constructor() {}

//   setupSocketConnection() {
//     this.socket = io('https://socket-it-service.wanorn.com');

//     console.log(this.socket);

//     // this.socket.emit('my message', 'Hello there from Vue.');
//   }
// }

// export default new SocketioService();


import { io } from "socket.io-client";

const socket = io("https://socket-it-service.wanorn.com", {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 2000
});

export default socket;